import { render, staticRenderFns } from "./message-stream.vue?vue&type=template&id=a1b5ad6c&scoped=true"
import script from "./message-stream.vue?vue&type=script&lang=ts"
export * from "./message-stream.vue?vue&type=script&lang=ts"
import style0 from "./message-stream.vue?vue&type=style&index=0&id=a1b5ad6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b5ad6c",
  null
  
)

export default component.exports